import * as React from "react";
import { _t } from "../../../utils/Translator";
import Partner from "../../../classes/Partner";
import "../RecipientChooser/RecipientChooser.css";

const defaultCompanyImageSrc = "assets/company_image.png";

export type CompanyContextCandidate = {
  id: number;
  name: string;
  email?: string;
  image?: string;
  sourceEmails: string[];
  contact?: Partner;
};

type CompanyChooserProps = {
  candidates: CompanyContextCandidate[];
  selectedCompanyId?: number;
  onSelect: (candidate: CompanyContextCandidate) => void;
};

const CompanyChooser = (props: CompanyChooserProps) => (
  <section className="recipient-chooser">
    <div className="section-card recipient-chooser__card">
      <div className="recipient-chooser__header">
        <div>
          <h2>{_t("Choose which company to use for Odoo context")}</h2>
          <p>
            {_t(
              "We found people from multiple companies in this email. Pick the company whose Odoo records you want to open."
            )}
          </p>
        </div>
      </div>

      <div className="recipient-chooser__list">
        {props.candidates.map(candidate => (
          <button
            type="button"
            key={candidate.id}
            className={`recipient-chooser__item ${props.selectedCompanyId === candidate.id ? "is-selected" : ""}`}
            onClick={() => props.onSelect(candidate)}
          >
            <img
              className="recipient-chooser__avatar recipient-chooser__avatar-image"
              src={candidate.image ? Partner.getImageDataUrl(candidate.image) : defaultCompanyImageSrc}
              alt={candidate.name}
              onError={event => {
                event.currentTarget.onerror = null;
                event.currentTarget.src = defaultCompanyImageSrc;
              }}
            />
            <div className="recipient-chooser__content">
              <div className="recipient-chooser__row">
                <span className="recipient-chooser__name">{candidate.name}</span>
              </div>
              {candidate.email && <div className="recipient-chooser__email">{candidate.email}</div>}
            </div>
          </button>
        ))}
      </div>
    </div>
  </section>
);

export default CompanyChooser;
